module.exports = __webpack_public_path__ + "img/image-01.1ad5d2c2.jpeg";